import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-97d52142"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Recurring Billing", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "alert" }, [
  /*#__PURE__*/_createElementVNode("b", null, "One Payment Account may be active at a time."),
  /*#__PURE__*/_createTextVNode(" The active payment account will be used for recurring billing ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Active Payment Account:", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["disabled", "onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Edit")
const _hoisted_10 = ["disabled", "onClick"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Add Payment Account ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Billing Date Offset", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " You can change the number of days after the due date to automatically charge the customer ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Note that changing this setting does not retroactively change the due date of already invoiced line items ", -1))
const _hoisted_15 = ["onSubmit"]
const _hoisted_16 = { class: "form-field" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Billing Date Offset", -1))
const _hoisted_18 = ["disabled"]
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Cancel")

import api from "@virgodev/bazaar/functions/api";
import { ref } from "vue";
import { paymentAccountInterface } from "@/types/customers";

export default /*#__PURE__*/_defineComponent({
  props: {
  customerId: {
    type: Number,
    required: true,
  },
  customerName: {
    type: String,
    required: true,
  },
  facilityId: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

// import { useRouter } from "vue-router";
const formErrors = ref<Record<string, string[]>>({});
const formSubmitting = ref(false);
const formFields = ref({
  charge_on_offset: ref(null),
});
const paymentAccounts = ref(Array<paymentAccountInterface>());
// const router = useRouter();

const errors = ref("");


async function submitForm() {
  const json = JSON.parse(JSON.stringify(formFields.value));
  formErrors.value = {};
  formSubmitting.value = true;
  let url = `offset_days/?id=${props.customerId}&facilityId=${props.facilityId}`;

  const responseData = await api({
    url,
    method: "PUT",
    json,
  });
  formSubmitting.value = false;

  if ([200, 201].includes(responseData.status)) {
    console.log("UPDATED");
  } else if (responseData.status === 400) {
    formErrors.value = responseData.body;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}
async function deleteAccount(id: string) {
  const response = await api({
    url: `payment_accounts/?id=${id}&facilityId=${props.facilityId}`,
    method: "DELETE",
  });
  if (response.status == 200) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let index = paymentAccounts.value.findIndex(function (item: any) {
      return item.id === id;
    });
    if (index != -1) {
      paymentAccounts.value.splice(index, 1);
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function changeActiveStatus(
  account: paymentAccountInterface,
  active: boolean
) {
  account.status = active.toString();
  const json = JSON.parse(
    JSON.stringify({
      active: account.status,
    })
  );
  formErrors.value = {};
  formSubmitting.value = true;
  let url = `payment_accounts/?id=${account.id}&facilityId=${props.facilityId}`;

  const responseData = await api({
    url,
    method: "PATCH",
    json,
  });
  formSubmitting.value = false;

  if ([200, 201].includes(responseData.status)) {
    await getPaymentAccounts();
  } else if (responseData.status === 400) {
    formErrors.value = responseData.body;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}
async function getOffsetDays() {
  errors.value = "";
  const response = await api({
    url: `offset_days/?id=${props.customerId}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    formFields.value.charge_on_offset = response.body.charge_on_offset;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
getOffsetDays();
async function getPaymentAccounts() {
  errors.value = "";
  const response = await api({
    url: `payment_accounts/?id=${props.customerId}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    paymentAccounts.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
getPaymentAccounts();

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_RouterLink, {
      to: {
      name: 'customer_detail_ess',
      params: { id: __props.customerId, facilityId: __props.facilityId },
    }
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Customer: " + _toDisplayString(__props.customerName), 1)
      ]),
      _: 1
    }, 8, ["to"]),
    _hoisted_1,
    _createElementVNode("fieldset", null, [
      _hoisted_2,
      _hoisted_3,
      (paymentAccounts.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentAccounts.value, (account) => {
              return (_openBlock(), _createElementBlock("div", {
                key: account.id + 'account',
                class: "well"
              }, [
                _createTextVNode(_toDisplayString(account.account_summary) + " ", 1),
                (!account.active)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", {
                        class: "btn",
                        disabled: formSubmitting.value,
                        onClick: ($event) => changeActiveStatus(account, true)
                      }, " Make Active ", 8, _hoisted_6),
                      _createElementVNode("div", {
                        class: "btn",
                        onClick: ($event: any) => (deleteAccount(account.id))
                      }, "Delete", 8, _hoisted_7)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_RouterLink, {
                        class: "btn",
                        to: {
              name: 'payment_account',
              params: {
                customerId: __props.customerId,
                customerName: __props.customerName,
                paymentAccountId: account.id,
                facilityId: __props.facilityId,
              },
            }
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createElementVNode("div", {
                        class: "btn",
                        disabled: formSubmitting.value,
                        onClick: ($event) => changeActiveStatus(account, false)
                      }, " Pause ", 8, _hoisted_10)
                    ]))
              ]))
            }), 128)),
            _createVNode(_component_RouterLink, {
              class: "btn",
              to: {
          name: 'payment_account',
          params: {
            customerId: __props.customerId,
            customerName: __props.customerName,
            facilityId: __props.facilityId,
          },
        }
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }, 8, ["to"])
          ]))
        : _createCommentVNode("", true),
      _hoisted_12,
      _hoisted_13,
      _hoisted_14,
      _createElementVNode("form", {
        class: "well",
        onSubmit: _withModifiers(submitForm, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formFields.value.charge_on_offset) = $event)),
            type: "number",
            required: ""
          }, null, 512), [
            [_vModelText, formFields.value.charge_on_offset]
          ])
        ]),
        _createElementVNode("button", {
          class: "btn",
          type: "submit",
          disabled: formSubmitting.value
        }, " Update ", 8, _hoisted_18),
        _createVNode(_component_RouterLink, {
          to: {
          name: 'customer_detail_ess',
          params: { id: __props.customerId, facilityId: __props.facilityId },
        }
        }, {
          default: _withCtx(() => [
            _hoisted_19
          ]),
          _: 1
        }, 8, ["to"])
      ], 40, _hoisted_15)
    ])
  ], 64))
}
}

})